import type { BundleStatus } from '../types/models.js';

export const BUNDLE_STATUSES: Record<BundleStatus, {
  label: string;
  description: string;
  color: string;
  bgColor: string;
  icon: string;
}> = {
  in_progress: {
    label: 'In Progress',
    description: 'Work items are being added and completed',
    color: '#3b82f6',
    bgColor: 'rgba(59, 130, 246, 0.1)',
    icon: 'loader',
  },
  ready_for_review: {
    label: 'Ready for Review',
    description: 'All items ready, awaiting client approval',
    color: '#f59e0b',
    bgColor: 'rgba(245, 158, 11, 0.1)',
    icon: 'eye',
  },
  approved: {
    label: 'Approved',
    description: 'Bundle approved by client',
    color: '#10b981',
    bgColor: 'rgba(16, 185, 129, 0.1)',
    icon: 'check-circle',
  },
  archived: {
    label: 'Archived',
    description: 'No longer active',
    color: '#9ca3af',
    bgColor: 'rgba(156, 163, 175, 0.1)',
    icon: 'archive',
  },
};

export const BUNDLE_STATUS_FLOW: Record<BundleStatus, BundleStatus[]> = {
  in_progress: ['ready_for_review', 'archived'],
  ready_for_review: ['in_progress', 'approved', 'archived'],
  approved: ['archived'],
  archived: ['in_progress'],
};
